import "@frog/source/index.less"

////////////
// Frame //
//////////

import frem from "@frog/source/utility/Resize.js"
import sizes from "@frog/source/data/sizes.js"

// frem({
//     "width": sizes.frame.width,
//     "height": sizes.frame.height,
// })
//
// const dom = document.getElementById("mount")
// dom.style.width = sizes.frame.width + "em"
// dom.style.height = sizes.frame.height + "em"

////////////////
// Game Loop //
//////////////

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"

import Loop from "@frog/source/utility/Loop.js"
import Render from "@frog/source/utility/Render.js"

Loop.start(function(delta) {
    Dev.atStartOfLoop()

    App.update(delta)
    Render()

    Dev.atEndOfLoop()
})

////////////////
// Analytics //
//////////////

import "@frog/source/analytics.js"

///////////////////
// Key Defaults //
/////////////////

window.addEventListener("keydown", (event) => {
    if(event.key == "s"
    && event.metaKey == true) {
        event.preventDefault()
    }
})
